<template>
  <div class="login">
    <h1>Sign In</h1>
    <input type="text" v-model="email" placeholder="Email"><br>
    <input type="password" v-model="password" placeholder="Password"><br>
    <button v-on:click="signIn">Sign In</button>
    <!--<p>You don't have an account ? You can <router-link to="/sign-up">create one</router-link></p>-->
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import firebase from 'firebase';

  export default {
    name: 'login',
    data() {
      return {
        email: '',
        password: '',
      };
    },
    methods: {
      ...mapActions('Firebase', ['initializeFirebaseCustomer', 'connectCustomerFirebase']),
      async signIn() {
        const authApp = await firebase.app('secondary');

        // try {
        //   const user = await authApp.auth().signInWithEmailAndPassword(this.email, this.password);
        //   console.log(user);
        //   const config = await this.connectCustomerFirebase();
        //   console.log(config);
        //   if (config) {
        //     this.$router.replace('rooms');
        //   }
        // } catch (err) {
        //   console.log('logging in exception');
        //   alert(`Oops. ${err.message}`);
        // }
        authApp.auth().signInWithEmailAndPassword(this.email, this.password).then(
          async () => {
            await this.connectCustomerFirebase();
            const self = this;
            setTimeout(() => {
              self.$router.replace('rooms');
            }, 2000);
          },
          (err) => {
            alert(`Oops. ${err.message}`);
          },
        );
      },
    },
  };
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.login {
  margin-top: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
button {
  margin-top: 20px;
  width: 10%;
  cursor: pointer;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/modules/Login/Login.vue